import React, { useContext, useEffect } from 'react'

import { contextData } from '../../App'
import GalleryComponent from '../../components/GalleryComponent/GalleryComponent';
import YouTubePlayer from '../../components/youtubeComponent/youtube';


function GalleryPage() {

  const {isScrolled,setIsScrolled} = useContext(contextData);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsScrolled(true)
    return () => {
      setIsScrolled(false)
    }
  },[])

  return (
    <div className=''>
      <GalleryComponent/>
      <YouTubePlayer videoId="bxuRgNPGVUg" />
    </div>
  )
}

export default GalleryPage
